import axios from "axios";
import { normativeUrl } from "../Config/Url";

export const normativeService = {
  getItemNormatives,
  getNormativeList,
  updateNormativeList,
};

async function getItemNormatives(productGuid) {
  return axios
    .get(`${normativeUrl}/products/${productGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getNormativeList(productGuid) {
  return axios
    .get(`${normativeUrl}/${productGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function updateNormativeList(productGuid, data) {
  let normatives = data.map((i) => ({
    normativGuid: i.normativGuid,
    productGuid: i.productGuid,
    quantity: Number(i.quantity),
    isActive: Boolean(i.isActive),
  }));

  return axios
    .put(`${normativeUrl}/${productGuid}`, normatives)
    .then((res) => res)
    .catch((err) => err.response);
}
